import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useUser } from "../context";
import Page from "../components/Page";
import GlobalSpinner from "../components/Spinner";

function PublicRoute({ component: Component, ...rest }) {
	const {
		isLogged,
		isloading,
		tokens: { group },
	} = useUser();
	console.log(group);
	return (
		<Route
			{...rest}
			render={(props) =>
				isloading ? (
					<GlobalSpinner />
				) : !isLogged ? (
					<Component {...props}>
						<Page />
					</Component>
				) : (
					<Redirect
						to={{ pathname: group === "admin" ? "/explore-brands" : "/" }}
					/>
				)
			}
		/>
	);
}

export default PublicRoute;
